import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import { Plus, Minus } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import { useLogStore } from '@/stores/log';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableExpandFilters',
  setup(__props) {

    const logStore = useLogStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: _unref(logStore).allFiltersOpen ? 'ghost_destructive' : 'ghost',
    width: "narrow",
    class: "self-start",
    size: "xs",
    onClick: _unref(logStore).toggleAllFilters
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(logStore).allFiltersOpen ? _ctx.$t('activities.collapse') : _ctx.$t('activities.expand')) + " ", 1),
      (_unref(logStore).allFiltersOpen)
        ? (_openBlock(), _createBlock(_unref(Minus), {
            key: 0,
            class: "text-destructive"
          }))
        : (_openBlock(), _createBlock(_unref(Plus), {
            key: 1,
            class: "text-accent"
          }))
    ]),
    _: 1
  }, 8, ["variant", "onClick"]))
}
}

})